/**
 * Loader shared by the requests of apiInstance and apiInstanceV2.
 *
 * Several requests can be running at the same time (at reload the role, the user and the table data are
 * requested together), so the overlay is hidden only when the last request that showed it finishes, not
 * when the first one answers.
 */

// Requests that showed the overlay and did not finish yet //
let pendingRequests = 0;

/**
 * Shows the overlay and counts the request, marking its config so only this request decrements it.
 * @param {Object} config - Axios config of the request.
 */
export const showRequestOverlay = (config) => {
    config.countedOverlay = true;
    pendingRequests++;
    if (document.getElementById('overlay')) document.getElementById('overlay').style.display = 'block';
};

/**
 * Discounts the request and hides the overlay when no other request is waiting for it.
 * Requests that did not show the overlay (overlay: false) do not change it.
 * @param {Object} config - Axios config of the request that finished.
 */
export const hideRequestOverlay = (config) => {
    if (!config?.countedOverlay) return;
    config.countedOverlay = false;
    pendingRequests = Math.max(0, pendingRequests - 1);
    if (pendingRequests === 0 && document.getElementById('overlay')) {
        document.getElementById('overlay').style.display = 'none';
    }
};
